{
  "genres": [
    {
      "name": "Rock",
      "description": "Rock is a broad genre of popular music that originated in the 1950s, rooted in rhythm and blues and country music. It's characterized by electric guitars, drums, and strong backbeat.",
      "interesting_facts": "Rock music has had a major influence on culture and has spawned many subgenres. It’s known for its rebellious spirit and powerful performances.",
      "artists": [
        "The Beatles",
        "Led Zeppelin",
        "The Rolling Stones"
      ],
      "websites": [
        "https://www.rollingstone.com/",
        "https://www.rockandrollhalloffame.org/",
        "https://www.nme.com/"
      ]
    },
    {
      "name": "Alternative",
      "description": "Alternative music is a diverse genre that originated in the 1980s and became popular in the 1990s. It blends elements of punk, new wave, and experimental rock.",
      "interesting_facts": "Known for its anti-commercial ethos, alternative music has helped shape modern rock, with many artists mixing different styles to create something unique.",
      "artists": [
        "Nirvana",
        "Radiohead",
        "Pearl Jam"
      ],
      "websites": [
        "https://www.altpress.com/",
        "https://www.nme.com/",
        "https://www.spin.com/"
      ]
    },
    {
      "name": "Metal",
      "description": "Metal is a genre of rock music that developed in the late 1960s and early 1970s, with roots in hard rock and psychedelic rock. It’s known for its heavy sound, distorted guitars, and powerful rhythms.",
      "interesting_facts": "Metal has spawned numerous subgenres like thrash, death, and black metal. It has a large, dedicated fanbase and often explores themes of rebellion and fantasy.",
      "artists": [
        "Metallica",
        "Iron Maiden",
        "Black Sabbath"
      ],
      "websites": [
        "https://www.metal-archives.com/",
        "https://www.loudersound.com/",
        "https://www.metalhammer.com/"
      ]
    },
    {
      "name": "Punk",
      "description": "Punk rock is a fast, aggressive genre that emerged in the mid-1970s as a reaction against mainstream rock and societal norms. It's known for its DIY ethos and political or anti-establishment themes.",
      "interesting_facts": "Punk music was an essential part of the counterculture movement in the late 20th century and has heavily influenced fashion, art, and politics.",
      "artists": [
        "The Ramones",
        "Sex Pistols",
        "The Clash"
      ],
      "websites": [
        "https://www.punknews.org/",
        "https://www.roland.com/us/learn/the-history-of-punk/",
        "https://www.altpress.com/"
      ]
    },
    {
      "name": "Indie",
      "description": "Indie rock is a genre that originated in the 1980s and is known for its independent approach to production and distribution. It blends a variety of styles, often with an emphasis on non-mainstream sound.",
      "interesting_facts": "Indie music has been credited with the rise of independent music labels and artists who work outside the traditional industry system.",
      "artists": [
        "Arcade Fire",
        "The Strokes",
        "Vampire Weekend"
      ],
      "websites": [
        "https://www.indie88.com/",
        "https://www.stereogum.com/",
        "https://pitchfork.com/"
      ]
    },
    {
      "name": "Grunge",
      "description": "Grunge is a subgenre of alternative rock that emerged in the late 1980s and became hugely popular in the early 1990s. It's known for its raw, distorted sound and themes of disillusionment and rebellion.",
      "interesting_facts": "Grunge was heavily associated with Seattle’s music scene and became synonymous with the cultural shift of the '90s, influencing fashion and attitudes.",
      "artists": [
        "Nirvana",
        "Soundgarden",
        "Pearl Jam"
      ],
      "websites": [
        "https://www.nme.com/",
        "https://www.sputnikmusic.com/",
        "https://www.rollingstone.com/"
      ]
    },
    {
      "name": "Funk",
      "description": "Funk is a genre of music that originated in the 1960s, combining elements of jazz, soul, and rhythm and blues. It emphasizes a strong, danceable groove with bass lines and rhythmic guitar.",
      "interesting_facts": "Funk music influenced the development of disco and hip hop, and is known for its infectious rhythms and emphasis on live performance.",
      "artists": [
        "James Brown",
        "George Clinton",
        "Sly and the Family Stone"
      ],
      "websites": [
        "https://www.funkology.com/",
        "https://www.rhino.com/",
        "https://www.allmusic.com/"
      ]
    },
    {
      "name": "Blues",
      "description": "Blues is a genre rooted in African American musical traditions, characterized by its use of specific chord progressions and themes of sorrow and resilience.",
      "interesting_facts": "Blues has had a profound impact on the development of many genres, including jazz, rock, and country music.",
      "artists": [
        "B.B. King",
        "Muddy Waters",
        "Robert Johnson"
      ],
      "websites": [
        "https://www.americanbluesscene.com/",
        "https://www.allaboutbluesmusic.com/",
        "https://www.blues.org/"
      ]
    },
    {
      "name": "Jazz",
      "description": "Jazz originated in the early 20th century in African American communities and is known for its complex rhythms, improvisation, and blend of multiple musical influences.",
      "interesting_facts": "Jazz is often regarded as one of the most influential music genres, with artists improvising on the spot and blending various styles like blues, classical, and swing.",
      "artists": [
        "Miles Davis",
        "Louis Armstrong",
        "John Coltrane"
      ],
      "websites": [
        "https://www.jazz.org/",
        "https://www.allaboutjazz.com/",
        "https://www.downbeat.com/"
      ]
    },
    {
      "name": "Oldies",
      "description": "Oldies refers to classic pop, rock, and rhythm and blues music from the late 1950s through the 1970s. It’s a nostalgic genre often played on retro radio stations.",
      "interesting_facts": "The oldies genre features some of the most iconic and enduring songs in music history, from the early days of rock 'n' roll to soul and Motown.",
      "artists": [
        "Elvis Presley",
        "The Beach Boys",
        "Chuck Berry"
      ],
      "websites": [
        "https://www.oldies.com/",
        "https://www.oldiesradio.com/",
        "https://www.classicbands.com/"
      ]
    },
    {
      "name": "Country",
      "description": "Country music blends folk, Western, and blues, with its roots in the Southern United States. It's known for its storytelling, simple harmonies, and use of string instruments like guitars, banjos, and fiddles.",
      "interesting_facts": "Country music has evolved significantly over the years, blending with rock, pop, and even hip-hop to create various subgenres.",
      "artists": [
        "Johnny Cash",
        "Dolly Parton",
        "Willie Nelson"
      ],
      "websites": [
        "https://www.cmt.com/",
        "https://www.countrymusic.com/",
        "https://www.allcountrynews.com/"
      ]
    },
    {
      "name": "Reggae",
      "description": "Reggae originated in Jamaica in the late 1960s, blending elements of ska, rocksteady, and rhythm and blues. It's known for its laid-back rhythms, socially conscious lyrics, and strong focus on the bassline.",
      "interesting_facts": "Reggae is closely associated with the Rastafarian movement and became globally popular through the music of Bob Marley. The offbeat rhythm, known as the 'one drop,' is a defining characteristic.",
      "artists": [
        "Bob Marley",
        "Peter Tosh",
        "Toots and the Maytals"
      ],
      "websites": [
        "https://www.reggae-vibes.com/",
        "https://www.jamaicansmusic.com/",
        "https://www.reggae.co.uk/"
      ]
    },
    {
      "name": "Pop",
      "description": "Pop music is characterized by its catchy melodies, simple lyrics, and mass appeal. It spans a wide range of styles and is produced to appeal to a broad audience.",
      "interesting_facts": "Pop music has evolved through decades, incorporating elements from other genres like rock, dance, and electronic music. It's often associated with chart-topping hits and mainstream success.",
      "artists": [
        "Michael Jackson",
        "Madonna",
        "Ariana Grande"
      ],
      "websites": [
        "https://www.billboard.com/pop/",
        "https://www.popjustice.com/",
        "https://www.rollingstone.com/music/pop/"
      ]
    },
    {
      "name": "K-pop",
      "description": "K-pop, short for Korean pop, is a genre originating from South Korea that combines elements of pop, hip-hop, R&B, and electronic dance music. It's known for its highly produced music, catchy melodies, and impressive choreography.",
      "interesting_facts": "K-pop's global success has skyrocketed in recent years, with groups like BTS and BLACKPINK achieving massive international popularity and becoming cultural phenomena.",
      "artists": [
        "BTS",
        "BLACKPINK",
        "EXO"
      ],
      "websites": [
        "https://www.soompi.com/",
        "https://www.allkpop.com/",
        "https://www.koreaboo.com/"
      ]
    },
    {
      "name": "Hip-hop",
      "description": "Hip-hop is a cultural movement that originated in the Bronx, New York, in the 1970s. It blends rapping, DJing, graffiti art, and breakdancing, with rap as its central musical element.",
      "interesting_facts": "Hip-hop has grown into a dominant genre globally, influencing fashion, language, and culture. It has evolved from a niche movement into a major force in mainstream music.",
      "artists": [
        "Tupac Shakur",
        "The Notorious B.I.G.",
        "Jay-Z"
      ],
      "websites": [
        "https://www.hotnewhiphop.com/",
        "https://www.complex.com/music/hip-hop",
        "https://www.rap-up.com/"
      ]
    },
    {
      "name": "Rap",
      "description": "Rap is a genre of music that features rhythmic and rhyming speech, often delivered in a fast-paced manner. It originated in African American communities and became popular in the 1980s.",
      "interesting_facts": "Rap music is a key component of hip-hop culture and often addresses themes of social issues, storytelling, and personal experiences.",
      "artists": [
        "Eminem",
        "Kendrick Lamar",
        "Drake"
      ],
      "websites": [
        "https://www.xxlmag.com/",
        "https://www.allmusic.com/genre/rap-ma0000002822",
        "https://www.rapgenius.com/"
      ]
    },
    {
      "name": "R and B",
      "description": "Rhythm and Blues (R&B) is a genre that originated in the African American community, combining jazz, gospel, and blues. It's known for smooth, soulful vocals and strong backbeats.",
      "interesting_facts": "R&B has heavily influenced pop and hip-hop music. The genre has seen several evolutions, from early Motown to modern-day smooth, electronic-infused rhythms.",
      "artists": [
        "Aretha Franklin",
        "Beyoncé",
        "Usher"
      ],
      "websites": [
        "https://www.rnbjunk.com/",
        "https://www.billboard.com/charts/r-and-b-songs/",
        "https://www.rnbmusicblog.com/"
      ]
    },
    {
      "name": "Trap",
      "description": "Trap is a subgenre of hip-hop that emerged in the Southern United States in the early 2000s. It's characterized by its use of aggressive beats, hi-hats, and 808 bass, along with dark, often gritty lyrics.",
      "interesting_facts": "Trap has become one of the dominant sounds in modern rap, influencing pop, EDM, and other genres with its hard-hitting beats and catchy hooks.",
      "artists": [
        "Future",
        "Migos",
        "Travis Scott"
      ],
      "websites": [
        "https://www.trapnation.co/",
        "https://www.xxlmag.com/rap-music/trap/",
        "https://www.complex.com/music/trap/"
      ]
    },
    {
      "name": "Dance",
      "description": "Dance music is created specifically for dancing, often played in clubs and at parties. It's known for its upbeat tempo, catchy melodies, and electronic production.",
      "interesting_facts": "Dance music covers a broad range of styles, from disco to modern EDM, and has been central to club culture for decades.",
      "artists": [
        "David Guetta",
        "Calvin Harris",
        "Zedd"
      ],
      "websites": [
        "https://www.dancingastronaut.com/",
        "https://www.edm.com/",
        "https://www.billboard.com/charts/dance-electronic-songs/"
      ]
    },
    {
      "name": "Disco",
      "description": "Disco is a genre of dance music that emerged in the 1970s, known for its four-on-the-floor beat, funky basslines, and orchestral arrangements. It was a cultural phenomenon in nightclubs.",
      "interesting_facts": "Disco's popularity in the 1970s led to the 'disco inferno,' and though its mainstream popularity declined, it still influences modern dance music.",
      "artists": [
        "Bee Gees",
        "Donna Summer",
        "Chic"
      ],
      "websites": [
        "https://www.discogs.com/",
        "https://www.rollingstone.com/music/music-lists/the-25-greatest-disco-songs-of-all-time-12150/",
        "https://www.dance365.com/"
      ]
    },
    {
      "name": "Classic Hits",
      "description": "Classic Hits refers to popular music from the late 1960s to the 1980s, often associated with rock, pop, and R&B. These songs have stood the test of time and continue to be beloved by many.",
      "interesting_facts": "Classic hits are often played on 'oldies' radio stations and represent a golden era of music that shaped the sound of the 20th century.",
      "artists": [
        "The Beatles",
        "Elton John",
        "Queen"
      ],
      "websites": [
        "https://www.classichits.com/",
        "https://www.oldies.com/",
        "https://www.classicrock.com/"
      ]
    },
    {
      "name": "Electronic Dance Music",
      "description": "Electronic Dance Music (EDM) is a broad range of percussive electronic music genres, typically produced for nightclubs and festivals. It emphasizes electronic sounds, synths, and rhythm-based production.",
      "interesting_facts": "EDM exploded in popularity in the 2010s, with large-scale music festivals like Tomorrowland and Ultra Music Festival attracting millions of fans globally.",
      "artists": [
        "Avicii",
        "Calvin Harris",
        "Martin Garrix"
      ],
      "websites": [
        "https://www.edm.com/",
        "https://www.dancingastronaut.com/",
        "https://www.festivalsinsider.com/edm/"
      ]
    },
    {
      "name": "Drum and Bass",
      "description": "Drum and Bass (D&B) is an electronic music genre characterized by fast-paced breakbeats (typically 160-180 BPM), heavy basslines, and complex rhythms.",
      "interesting_facts": "Drum and Bass originated in the UK in the 1990s and has since become a global genre, influencing multiple subgenres of electronic music.",
      "artists": [
        "Goldie",
        "Andy C",
        "Pendulum"
      ],
      "websites": [
        "https://www.drumandbassarena.com/",
        "https://www.liquiddnb.com/",
        "https://www.ukf.com/"
      ]
    },
    {
      "name": "House",
      "description": "House music is a genre of electronic dance music that originated in the early 1980s in Chicago. It’s characterized by its repetitive 4/4 beats, synthesized basslines, and use of piano or other melodies.",
      "interesting_facts": "House music is one of the most influential genres in dance music culture and has spawned many subgenres such as deep house, progressive house, and tech house.",
      "artists": [
        "Frankie Knuckles",
        "Daft Punk",
        "Calvin Harris"
      ],
      "websites": [
        "https://www.residentadvisor.net/",
        "https://www.dancingastronaut.com/",
        "https://www.housemusic.net/"
      ]
    },
    {
      "name": "Techno",
      "description": "Techno is a genre of electronic dance music that emerged in Detroit in the mid-1980s. It is defined by its repetitive beats, synthesizer-driven melodies, and futuristic sound.",
      "interesting_facts": "Techno became a cornerstone of the rave and underground electronic dance scenes, and its influence can be heard in various electronic music styles today.",
      "artists": [
        "Carl Cox",
        "Richie Hawtin",
        "Derrick May"
      ],
      "websites": [
        "https://www.technofeed.com/",
        "https://www.residentadvisor.net/",
        "https://www.dancingastronaut.com/"
      ]
    },
    {
      "name": "Soul",
      "description": "Soul music is a genre that combined elements of African-American gospel music, rhythm and blues, and jazz. It is characterized by its intense emotional delivery, call-and-response structures, and an emphasis on vocal improvisation and rhythmic grooves.",
      "interesting_facts": "Soul music emerged in the late 1950s and became a soundtrack for the Civil Rights Movement; the term 'Soul' was used to emphasize the pride and 'soulfulness' of African American culture during a time of social upheaval.",
      "artists": [
        "Otis Redding",
        "Sam Cooke",
        "Marvin Gaye",
        "Ray Charles",
        "Aretha Franklin"
      ],
      "websites": [
        "https://www.staxmuseum.com/",
        "https://www.motownmuseum.org/",
        "https://www.allmusic.com/genre/soul-ma0000002855"
      ]
    },
    {
      "name": "News",
      "description": "News music refers to music that accompanies news broadcasts, typically in the form of jingles, theme songs, or background scores that enhance the delivery of information.",
      "interesting_facts": "News music is often composed to evoke certain emotions, such as urgency or gravity, and is designed to complement the tone of news stories.",
      "artists": [
        "John Williams (for news themes)",
        "Alan Silvestri (for news score work)",
        "Hans Zimmer (occasional news theme work)"
      ],
      "websites": [
        "https://www.npr.org/sections/news/",
        "https://www.bbc.com/news",
        "https://www.cnn.com/"
      ]
    },
    {
      "name": "Classical",
      "description": "Classical music is a broad genre of music that spans several centuries, typically characterized by its orchestral arrangements, complex structures, and emphasis on harmony and melody.",
      "interesting_facts": "Classical music is often associated with composers such as Mozart, Beethoven, and Bach, and it continues to influence contemporary music and film scores.",
      "artists": [
        "Ludwig van Beethoven",
        "Wolfgang Amadeus Mozart",
        "Johann Sebastian Bach"
      ],
      "websites": [
        "https://www.classical-music.com/",
        "https://www.bbc.co.uk/programmes/b006tnz9",
        "https://www.npr.org/sections/deceptivecadence/"
      ]
    },
    {
      "name": "Gospel",
      "description": "Gospel music is a genre of Christian music that originated in African American churches, known for its powerful vocals, uplifting messages, and use of choirs and spirituals.",
      "interesting_facts": "Gospel music has deeply influenced soul, R&B, and pop music, with artists like Mahalia Jackson and Aretha Franklin paving the way for future generations.",
      "artists": [
        "Mahalia Jackson",
        "Kirk Franklin",
        "Aretha Franklin"
      ],
      "websites": [
        "https://www.gospelmusic.org/",
        "https://www.blackgospel.com/",
        "https://www.allmusic.com/genre/gospel-ma0000002653"
      ]
    },
    {
      "name": "Folk",
      "description": "Folk music is characterized by its traditional, acoustic sound, often with storytelling lyrics that reflect the culture, history, or personal experiences of the people.",
      "interesting_facts": "Folk music has played a crucial role in social and political movements, especially in the 1960s, and remains a beloved genre for its raw, unpolished sound.",
      "artists": [
        "Bob Dylan",
        "Joan Baez",
        "Simon & Garfunkel"
      ],
      "websites": [
        "https://www.folkmusic.com/",
        "https://www.folkmusic.co.uk/",
        "https://www.pastemagazine.com/music/folk/"
      ]
    },
    {
      "name": "Podcast",
      "description": "Podcasts are a form of digital audio content, often featuring interviews, storytelling, or discussions on a variety of topics. While not a traditional music genre, podcasts often include music as part of the production.",
      "interesting_facts": "Podcasts have exploded in popularity in the past decade, becoming a central medium for news, education, and entertainment, with music often used to enhance storytelling.",
      "artists": [
        "Serial Podcast",
        "This American Life",
        "The Joe Rogan Experience"
      ],
      "websites": [
        "https://www.podcastone.com/",
        "https://www.stitcher.com/",
        "https://www.spotify.com/podcasts/"
      ]
    },
    {
      "name": "Sports",
      "description": "Sports music typically refers to music used in association with sports broadcasts, events, or fan experiences, including anthems, fight songs, and motivational tracks.",
      "interesting_facts": "Music in sports helps energize the audience and players, with some songs becoming iconic to particular teams or sports events.",
      "artists": [
        "John Williams (Star Wars theme for sports events)",
        "Queen (We Are the Champions)",
        "AC/DC (Thunderstruck)"
      ],
      "websites": [
        "https://www.espn.com/",
        "https://www.sportsillustrated.com/",
        "https://www.nfl.com/"
      ]
    }
  ]
}
